import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { ClientSidePermissionsEffects } from "./effects/client-side-permission.effects";
 
export const clientSidePermissionsEffectsModule = EffectsModule.forFeature([ClientSidePermissionsEffects])

@NgModule({
  imports: [
    clientSidePermissionsEffectsModule
  ]
})
export class ClientSidePermissionModule { }
